import { useState } from "react";
import { useAuth } from "../lib/auth";
import { Link, useNavigate } from "react-router-dom";
import { LogIn, Mail, Lock, AlertCircle, Loader2, FileCheck } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/app");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page" data-testid="login-page">
      <div className="auth-card">
        <div className="auth-header">
          <Link to="/" className="auth-logo-link">
            <div className="lp-logo-icon"><FileCheck size={16} /></div>
            <span className="auth-logo">ResumeAI</span>
          </Link>
          <h1>Welcome back</h1>
          <p>Sign in to your account</p>
        </div>

        {error && (
          <div className="auth-error" data-testid="login-error">
            <AlertCircle size={16} />
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label htmlFor="email">Email</label>
            <div className="auth-input-wrap">
              <Mail size={16} className="auth-input-icon" />
              <input
                id="email"
                type="email"
                placeholder="you@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email"
              />
            </div>
          </div>

          <div className="auth-field">
            <label htmlFor="password">Password</label>
            <div className="auth-input-wrap">
              <Lock size={16} className="auth-input-icon" />
              <input
                id="password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                data-testid="login-password"
              />
            </div>
          </div>

          <button type="submit" className="auth-btn" disabled={loading} data-testid="login-submit">
            {loading ? <Loader2 size={18} className="spin" /> : <LogIn size={18} />}
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="auth-footer" style={{ marginTop: "0.75rem" }}>
          <Link to="/forgot-password" data-testid="goto-forgot-password">Forgot your password?</Link>
        </div>

        <div className="auth-footer">
          Don't have an account?{" "}
          <Link to="/signup" data-testid="goto-signup">Sign up free</Link>
        </div>
      </div>
    </div>
  );
}
